import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
}
export const fetchAllSetting = createAsyncThunk(
    "fetchAllSetting",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/layout/fetch-all-about?page=${body.page}&search=${body.search}`);
            return response.data;

        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const SettingSlice = createSlice({
    name: 'SettingSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllSetting.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchAllSetting.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
            state.count = action?.payload?.count;
        })
        builder.addCase(fetchAllSetting.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });



    },

})

export default SettingSlice.reducer;